import React from 'react';
import Slider from '@material-ui/lab/Slider';
import $ from 'jquery';

// hover時のvalueを利用できるSlider
export default class HoverableSlider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isHover: false,
      hoverValue: -1,
      value:0,
      isDrag: false,
    };
    this.superRef = React.createRef();
  }

  handleMouseEnter = (e) => {
    this.setState({ isHover: true });
    if (this.props.onHoverStart) {
      this.props.onHoverStart(e);
    }
    //const position = e.clientX - this.superRef.current.getTrackOffset();
    const position = e.clientX - $('.slider').offset().left;
    this.setHoverValueFromPosition(e, position);
  }

  handleMouseLeave = (e) => {
    this.setState({ isHover: false });
    if (this.props.onHoverEnd) {
      this.props.onHoverEnd(e);
    }
  }

  handleMouseMove = (e) => {
    //const position = e.clientX - this.superRef.current.getTrackOffset();
    const position = e.clientX - $('.slider').offset().left;
    this.setHoverValueFromPosition(e, position);
  }

  handleOnChange = (event, value) => {
    console.log('handleOnChange');
    this.setState({value: value});
    //this.props.onChange(event, value);
  }

  onDragStart = () => {
    this.setState({isDrag: true});
    if (this.props.onDragStart) {
      this.props.onDragStart();
    }
  }

  onDragEnd = () => {
    this.setState({isDrag: false});
    if (this.props.onDragEnd) {
      this.props.onDragEnd();
    }
  }

  setHoverValueFromPosition = (event, position) => {
    const value = this.getHoverValueAtPosition(position);
    if (this.state.hoverValue !== value) {
      this.setState({ hoverValue: value });

      if (this.props.onHoverChange) {
        this.props.onHoverChange(event, value);
      }
    }
  }

  getHoverValueAtPosition = (position) => {
    const min = this.superRef.current.props.min;
    const max = this.superRef.current.props.max;
    const step = this.superRef.current.props.step;
    //const positionMax = this.superRef.current.track.clientWidth;
    const positionMax = $('.slider').width();

    let value;
    if (position <= 0) {
      value = min;
    } else if (position >= positionMax) {
      value = max;
    } else {
      value = position / positionMax * (max - min);
      value = Math.round(value / step) * step + min;
      value = parseFloat(value.toFixed(5));
    }
    //return this.superRef.current.resolveValue(value, min, max);
    return parseInt(value);
  }

  componentWillMount = () => {
    //var self = this;
    // kuromoji.builder({ dicPath: "./dict/" }).build(function (err, tokenizer) {
    //   self.setState({tokenizer: tokenizer});
    // });
    this.setState({value: this.props.value});
  }
  componentWillReceiveProps = (nextProps) => {
    if (nextProps.value !== undefined && !this.state.isDrag) {
      this.setState({value: nextProps.value});
    }
  }

  render = () => {
    let {
      onHoverStart,
      onHoverChange,
      onHoverEnd,
      onChange,
      onDragStart,
      onDragEnd,
      value,
      ...sliderProps
    } = this.props;
    const superRef = this.superRef;
    return (
      <Slider
        {...sliderProps}
        ref={superRef}
        className="slider"
        value={this.state.value}
        onMouseEnter={this.handleMouseEnter}
        onMouseMove={this.handleMouseMove}
        onMouseLeave={this.handleMouseLeave}
        onChange={this.handleOnChange}
        onDragStart={this.onDragStart}
        onDragEnd={this.onDragEnd}
        step={1}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/HoverableSlider.js